module.exports = __webpack_public_path__ + "static/media/Chult1.f8dfa5fb.jpg";